import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpUtilsService } from '../../../core/services/http-utils.service';
import { AppSettings } from './../../../app.config';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { QueryParamsModel } from '../../../core/models/query-models/query-params.model';
import { Observable, of, throwError } from 'rxjs';
import { QueryResultsModel } from '../../../core/models/query-models/query-results.model';
import { User } from '../../../core/models/user';
import { Person } from '../models/person.model';
import { ApiRequestParam } from '../models/request-entity/api-request-param';
import { UserType } from '../models/constants/user-type';
import { Roles } from '../models/constants/role';
import { CreateUserRequestModel } from '../../../core/models/createuserrequest.model';

const API_URL: string = AppSettings.API_ENDPOINT + 'user';

@Injectable({
    providedIn: 'root',
})

export class UserService {
    public urls: string;
    constructor(
        private http: HttpClient, private httpUtils: HttpUtilsService) {
    }

    public getByPersonId(id: number) {
        if (!id) {
            return;
        }
        const url = API_URL;
        let params = new HttpParams();
        params = params.append('id', id.toString());
        return this.http.get(url, { params }).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public create(createUserRequest: CreateUserRequestModel) {
        const url = API_URL;
        return this.http.post(url, createUserRequest).pipe(
            map((result: any) => {
                return result;
            }),
            catchError(error => {
              return throwError(error);
            }
        ));
    }

    public update(createUserRequest: CreateUserRequestModel) {
        const url = API_URL;
        return this.http.put(url, createUserRequest).pipe(
            map((result: any) => {
                return result;
            }),
            catchError(error => {
              return throwError(error);
            }
        ));
    }

    public updatePerson(user: User) {
        const url = API_URL + '/updatePerson';
        return this.http.put(url, user).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public updatePassword(user: User) {
        const url = API_URL + '/updatePassword';
        return this.http.put(url, user).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public findDirectorateUsers(queryParams: QueryParamsModel, role: string, type: string, directorateId?: number,
        roleFilterId?: number): Observable<QueryResultsModel> {
        let params = new HttpParams();
        const url = API_URL + '/list/directorate';
        params = params.append('directorateId', directorateId.toString());

        return this.http.get<User[]>(url, { params }).pipe(
            mergeMap(res => {
                let personList: Person[] = [];
                res.forEach(element => {
                    personList.push(Person.fromJsonResponse(element));
                });

                if (roleFilterId) {
                    personList = personList.filter(person =>
                        Array.isArray(person.roles) && person.roles.some(r => r && r.id === roleFilterId));
                }

                const result = this.httpUtils.baseFilter(personList, queryParams, []);
                return of(result);
            })
        );
    }

    public findUsers(queryParams: QueryParamsModel, role: string, type: string, directorateId?: number,
        coopId?: number, roleFilterId?: number): Observable<QueryResultsModel> {
        let params = new HttpParams();
        if (role === Roles.ADMIN.name) {
            if (type === UserType.DIRECTORATE.name) {
                this.urls = '/list/directorate';
                params = params.append('directorateId', directorateId.toString());
            } else if (type === UserType.COOP.name) {
                this.urls = '/list/coop';
                params = params.append('coopId', coopId.toString());
            } else if (type === UserType.MEMBER.name) {
                this.urls = '/list/member';
                params = params.append('coopId', coopId.toString());  // bunun memberId olması lazım
            }
        } else if (role === Roles.DIRECTORATE_ADMIN.name) {
            if (type === UserType.DIRECTORATE.name) {
                this.urls = '/list/directorate';
                params = params.append('directorateId', directorateId.toString());
            } else if (type === UserType.COOP.name) {
                this.urls = '/list/coop';
                params = params.append('coopId', coopId.toString());
            } else if (type === UserType.MEMBER.name) {
                this.urls = '/list/member';
                params = params.append('coopId', coopId.toString());  // bunun memberId olması lazım
            }
        } else if (role === Roles.COOP_ADMIN.name) {
            if (type === UserType.COOP.name) {
                this.urls = '/list/coop';
                params = params.append('coopId', coopId.toString());
            } else if (type === UserType.MEMBER.name) {
                this.urls = '/list/member';
                params = params.append('coopId', coopId.toString());  // bunun memberId olması lazım
            }
        }
        const url = API_URL + this.urls;
        return this.http.get<User[]>(url, { params }).pipe(
            mergeMap(res => {
                let personList: Person[] = [];
                res.forEach(element => {
                    personList.push(Person.fromJsonResponse(element));
                });

                if (roleFilterId) {
                    personList = personList.filter(person =>
                        Array.isArray(person.roles) && person.roles.some(r => r && r.id === roleFilterId));
                }

                const result = this.httpUtils.baseFilter(personList, queryParams, []);
                return of(result);
            })
        );
    }

    public getByIdentity(apiRequestParam: ApiRequestParam) {
        const url = API_URL + '/getByIdentity';
        return this.http.post(url, apiRequestParam).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public fetchMe() {
        const url = API_URL + '/me';
        return new Promise((resolve, reject) => {
            this.http.get(url).subscribe(res => {
              resolve(res);
            }, (err) => {
              reject(err);
            });
        });
    }

    public toggleState  (userId: number) {
        const url = API_URL + '/toggleState';
        return this.http.put(url, userId).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public getDashboardFilter() {
        const url = API_URL + '/dashboard-filter';
        return this.http.get(url).pipe(
            map((result: any) => {
                return result;
            })
        );
    }

    public saveDashboardFilter(dashboardFilter: any) {
        const url = API_URL + '/dashboard-filter';
        return this.http.put(url, dashboardFilter).pipe(
            map((result: any) => {
                return result;
            })
        );
    }
}
